import React, { useState } from 'react'
import notetoStyle from './notetoaudienceInfo.module.css'
require('typeface-poppins')


export default function NotetoaudienceInfo({ noteFamily }) {

    const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open

    const handleToggle = (index) => {
        // Toggle between opening and closing the same accordion item
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <div className={`${notetoStyle.contactAccordion} accordion mb-3`} id="ContactInfo">
                <div className={`${notetoStyle.contactMainitem} accordion-item`}>
                    <h2 className="accordion-header">
                        <button className={`${notetoStyle.contactbuttonItem} ${notetoStyle.notetoBeforebg} accordion-button ${openIndex === 0 ? '' : `${notetoStyle.notetobgColor} collapsed`}`} type="button" onClick={() => handleToggle(0)} aria-expanded={openIndex === 0 ? 'true' : 'false'} aria-controls="collapseOne">
                            Note to Audience
                        </button>
                    </h2>
                    <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === 0 ? 'show' : ''}`} data-bs-parent="#ContactInfo">
                        <div className={`${notetoStyle.moreBody} accordion-body`}>
                            <div className={notetoStyle.infoWrapper}>
                                <p>{noteFamily}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}